namespace TabAurous.Finance {
    export interface ReceiptForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        LedgerId: Serenity.ServiceLookupEditor;
        LedgerName: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        EnteredBy: Serenity.LookupEditor;
        UserId: Serenity.IntegerEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        Details: ReceiptDetailsEditor;
        PartyBalance: PartyBalanceEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        KnockOffTotal: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class ReceiptForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.Receipt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptForm.init)  {
                ReceiptForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.IntegerEditor;
                var w6 = ReceiptDetailsEditor;
                var w7 = PartyBalanceEditor;

                Q.initFormType(ReceiptForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherNo', w0,
                    'LedgerId', w2,
                    'LedgerName', w0,
                    'CurrencyId', w3,
                    'ExchangeRate', w4,
                    'EnteredBy', w3,
                    'UserId', w5,
                    'RefNo', w0,
                    'RefDate', w1,
                    'Details', w6,
                    'PartyBalance', w7,
                    'VoucherTypeId', w5,
                    'KnockOffTotal', w4,
                    'TotalAmount', w4,
                    'Narration', w0,
                    'CompanyId', w5,
                    'FinancialYearId', w5
                ]);
            }
        }
    }
}
